import { render, staticRenderFns } from "./CertificateSave.vue?vue&type=template&id=573af74a&"
import script from "./CertificateSave.vue?vue&type=script&lang=js&"
export * from "./CertificateSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports